import type { SidebarDestination } from '@alison/ui';

//TEMP : Manual on/off switches for shell pieces while their real pages/features are
// still being built. Flip a value to false to hide it everywhere.
export const SHELL_CONFIG = {
  nav: {
    dashboard: true,
    workflows: true,
    reports: true,
    explore: true,
    signals: true,
    outcomes: true,
    studio: false,
    // Preflight-only clients get this entry instead of the rest; AppShell turns it on for them.
    batches: false,
    settings: true,
  } satisfies Record<SidebarDestination, boolean>,
  notifications: true,
  account: true,
};
